// extracted by mini-css-extract-plugin
export default {"bgHome":"Bghome_bgHome__oag8U","content":"Bghome_content__qYlIu","title":"Bghome_title__MEgnA","subtitle":"Bghome_subtitle__wV0+s"};